export interface Balance {
  collection: string;
  month: string;
  value: number;
}

const defaultState: Balance[] = [];

export default defaultState;
